export default{
    home: { dataObj : { content_page : [ ]}},
    packages: {},
    loading: false,
    error: "",
    pageNumber : 4
}